exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".first-support-link[data-v-1410766e] {\n  margin-top: 0 !important;\n}\n", ""]);

// exports
